import { ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Unit = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  mobile?: string
  role?: string
  dob?: string
  position?: string
  appartment?: String
  unit_info?: string
  two_steps?: boolean
  property_info?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UnitsQueryResponse = Response<Array<Unit>>

export const initialUnit: Unit = {
  avatar: 'avatars/300-6.jpg',
   position: 'Art Director',
   role: 'Administrator',
  name: '',
  email: '',
}
